import { FC, useEffect,MouseEvent } from "react";
import { useMutation } from "react-query";
import { Button, CircularProgress, Paper, TableContainer, Typography } from "@mui/material";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import TableComponent from "../component/TableComponent";
import moment from "moment";
import { encounterListReportexcelService, encounterListReportpdfService, encounterListReportService, getAllDoctor } from "./service";
import { clinicId } from "../../constants";
import usePrint from "../../hooks/usePrint";

const encouterListReport: FC = () => {
  const { control,reset,getValues } = useForm();
  const {printPdf}=usePrint()
  const {
    mutate: getencounterReport,
    data: Data,
    isLoading:encounterDataLoading,
    reset:resetMutation
  } = useMutation(encounterListReportService);
  const {
    mutate: getencounterReportpdf,
    isLoading: encounterDatapdfLoading,
  } = useMutation(encounterListReportpdfService,{onSuccess:(data)=>{printPdf(data.response.file)}});
  const {
    mutate: getencounterReportexcel,
    isLoading: encounterDataexcelLoading,
  } = useMutation(encounterListReportexcelService,{onSuccess:(data)=>{printPdf(data.response,"new-tab","xlsx")}});

     const { mutate: getalldoctors, data: doctorsList } =
        useMutation(getAllDoctor);

const onChange = ()=>{
  const data = getValues();
  if(data?.fromDate && data?.toDate){
    const body={
      fromDate:data.fromDate,
      toDate:data.toDate,
      doctorName:data.doctorName?.name,
      clinicId
    }
    getencounterReport(body);
  }else{
    resetMutation()
  }
}
const clearForm = () => {
  reset({
    fromDate: "",
    toDate: ""
  });
  resetMutation()
}

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
        const fileType = e.currentTarget.dataset.filetype;
        const allData = getValues();
        if (fileType === "pdf") {
          getencounterReportpdf({
            fromDate: allData.fromDate,
            toDate: allData.toDate,
            doctorName: allData.doctorName?.name,
            clinicId
          });
        } else {
          getencounterReportexcel({
            fromDate: allData.fromDate,
            toDate: allData.toDate,
            doctorName: allData.doctorName?.name,
            clinicId
          });
        }
      };

  useEffect(() => {
    getencounterReport({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      clinicId
    });
    reset({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    })
    getalldoctors()
  }, []);

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
             Encounter List Report
          </Typography>
        </div>
        <form 
        // onSubmit={handleSubmit(onSubmit)}
         className="grid grid-cols-3 gap-3 p-4">
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "to Date" }}
            rules={{ required: "From Date is required",onChange }}
          />

             <CustomFormField
               control={control}
               element="autocomplete"
               name="doctorName"
               options={doctorsList || []}
               rules={{ required: false, onChange }}
               fieldProps={{ label: "Doctor :",defaultValue:"All"}}
               autocompleteProps={{
                 getOptionLabel: (option: { id: number; name: string }) =>
                   option.name,
                 isOptionEqualToValue: (option, value) => {
                   return option.id == value.id;
                 },
               }}
             />
           
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button type="submit">search</Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
        <Button
                  disabled={encounterDatapdfLoading || !Boolean(Data?.response?.length)}
                  endIcon={encounterDatapdfLoading && <CircularProgress size={18} />}
                  data-filetype="pdf"
                  onClick={getFiles}
                >
                  pdf
                </Button>
                <Button
                  disabled={encounterDataexcelLoading || !Boolean(Data?.response?.length)}
                  endIcon={encounterDataexcelLoading && <CircularProgress size={18} />}
                  data-filetype="excel"
                  onClick={getFiles}
                >
                  excel
                </Button>
        </div>
        <TableComponent
          loading={encounterDataLoading}
          data={Data?.response || []}
          tableProps={heading}
          paginationChange={(prop)=>{console.log(prop)}}
        />
      </TableContainer>
    </div>
  );
};

export default encouterListReport;
const heading = [
  { heading: "EMR NO/REG NO", key: "patientID" },
  { heading: "NAME", key: "patientName" },
  { heading: "AGE", key: "age" },
  { heading: "GENDER", key: "gender" },
  { heading: "NATIONALITY", key: "nationality" },
  { heading: "DOCTOR", key: "doctorname" },
  { heading: "DEPARTMENT", key: "deptname" },
  { heading: "MOBILE NO", key: "mobileNo" },
  { heading: "REGISTERED DATE", key: "foDate",date:"DD-MM-YYYY hh:mm A",format:"DD/MM/YYYY HH:mm:ss" }
];
